// extracted by mini-css-extract-plugin
module.exports = {"card":"AnchorEarnPromote_card__BBUPO","header":"AnchorEarnPromote_header__2ygJd","footer":"AnchorEarnPromote_footer__3hmhp"};